import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-site",
  "use": "google-site-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"google-site\"><g clip-path=\"url(#google-site_clip0_2_65)\"><rect width=\"16\" height=\"16\" rx=\"2\" fill=\"#4054B2\" /><path d=\"M2.5 3.5h11V6h-11V3.5zm0 4.5H8v4.5H2.5V8zm11 0H10v4.5h3.5V8z\" fill=\"#fff\" /></g><defs><clipPath id=\"google-site_clip0_2_65\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol